module.exports = __webpack_public_path__ + "assets/img/36_454.dd128dc5.jpg";